/*
 * @Author: lc
 * @Date: 2022-08-31 16:22:59
 * @LastEditors: lc
 * @LastEditTime: 2024-07-12 11:31:08
 * @Description: 
 */
/**
 * 匠人 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const tradesman = {
    /** ***********普通用户BEGIN***************/
    // 邮费模板列表
    shiptemplatelist (params) {
        return axios.get(api + 'tradesman/shiptemplatelist', { params: params })
    },
    // 自提点
    zitipointlist (params) {
        return axios.get(api + 'tradesman/zitipointlist', { params: params })
    },
    // 列表
    list (params) {
        return axios.get(api + 'tradesman/list', { params: params })
    },
    // 待审列表
    reviewlist (params) {
        return axios.get(api + 'tradesman/reviewlist', { params: params })
    },
    // 审核
    review (params) {
        return axios.post(api + 'tradesman/review', qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'tradesman/detail', { params: params })
    },
    remove (params) {
        return axios.post(api + 'tradesman/remove', qs.stringify(params))
    },
    edit (params) {
        return axios.post(api + 'tradesman/edit', qs.stringify(params))
    },
    create (params) {
        return axios.post(api + 'tradesman/create', qs.stringify(params))
    },
    // 分类列表
    catelist (params) {
        return axios.get(api + 'tradesman/catelist', { params: params })
    },
    // 技艺列表
    skilllist (params) {
        return axios.get(api + 'tradesman/skilllist', { params: params })
    },
    // 角色列表
    rolelist (params) {
        return axios.get(api + 'tradesman/rolelist', { params: params })
    },
    // 角色编辑
    roleedit (params) {
        return axios.post(api + 'tradesman/roleedit', qs.stringify(params))
    },
    // 导出收入
    exportShouru (params) {
        return axios.post(api + 'export/tradesmanShouru', qs.stringify(params))
    },
    //  导出订单
    exportOrder (params) {
        return axios.post(api + 'export/tradesmanOrder', qs.stringify(params))
    },
    //  导出支付订单
    exportPay (params) {
        return axios.post(api + 'export/payOrder', qs.stringify(params))
    },
    // 导出售出商品
    exportTradesmanGoods (params) {
        return axios.post(api + 'export/tradesmanGoods', qs.stringify(params))
    },
    // 导出有订单的匠人
    exportHavingOrderTrad (params) {
        return axios.post(api + 'export/havingordertrad', qs.stringify(params))
    },
    gongjianglist (params) {
        return axios.get(api + 'tradesman/gongjianglist', { params: params })
    },
    gongjiangdetail (params) {
        return axios.get(api + 'tradesman/gongjiangdetail', { params: params })
    },
    editgongjiang (params) {
        return axios.post(api + 'tradesman/editgongjiang', qs.stringify(params))
    },

}

// 导出接口
export default tradesman
